import { snapshot } from 'valtio'
import { endOfDay, formatISO, startOfDay } from 'date-fns'
import { buildAxiosInstance } from '../../../../../shared/utils/apiUtils'
import { type TransactionType } from '../../../../../shared/types/GlobalTranactionTypeEnum'
import { transactionsProxy } from '../../../../../shared/proxies/transactionsProxy'

const buildfetchParams = (): { [key in string]: string | number | readonly TransactionType[] } => {
  const { filters } = snapshot(transactionsProxy)

  const params: { [key in string]: string | number | readonly TransactionType[] } = {}

  if (filters.startDate) {
    params.startDate = formatISO(startOfDay(filters.startDate), { representation: 'date' })
  }
  if (filters.endDate) {
    params.endDate = formatISO(endOfDay(filters.endDate), { representation: 'date' })
  }

  if (filters.search) {
    params.search = filters.search
  }

  if (filters.transactionTypes && filters.transactionTypes.length > 0) {
    params.sslTransactionTypes = [...filters.transactionTypes]
  }

  return params
}

interface Args {
  displayLoader: boolean
  appendRecords?: boolean
  ignoreRecords?: boolean
}

export async function executeTransactionsExport ({ displayLoader = true }: Args): Promise<void> {
  if (displayLoader) { transactionsProxy.apiCall.loading = true }
  transactionsProxy.apiCall.error = null
  try {
    const params = buildfetchParams()
    const response = await buildAxiosInstance().post('/api/transactions/export', params)
    if (response.data.error) {
      transactionsProxy.apiCall.error = response.data.error
    }
  } catch (e) {
    if (e instanceof Error) {
      transactionsProxy.apiCall.error = e.message
    }
  } finally {
    if (displayLoader) { transactionsProxy.apiCall.loading = false }
  }
}
